import { VideoFeedback } from "@/enums/enums";
import { i18n } from "@/i18n";

export function GetYoutubeUrlFromPageName(urlName: string) {
  let youtubeUrlList = [];
  const setAndCreateClassificationGroup = {
    name: i18n.t("youtube_List.Set_And_Create_Classification_Group"),
    url: "3pz8B3o3BFg",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const editClassificationName = {
    name: i18n.t("youtube_List.Edit_Classification_Name"),
    url: "3xT1wW1vJaM",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const organizeExpenseRecordsWithClassification = {
    name: i18n.t("youtube_List.Organize_Expense_Records_With_Classification"),
    url: "AiAGNuwDKuo",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const organizeRevenueDocumentWithClassification = {
    name: i18n.t("youtube_List.Organize_Revenue_Document_With_Classification"),
    url: "uT-MhtvX0-U",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const groupExpenseItemsAcrossDifferenceClassificationInASingleRecord = {
    name: i18n.t("youtube_List.Group_Expense_Items_Across_Difference_Classification_In_A_Single_Record"),
    url: "VW84A_KhIoU",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const groupRevenueItemsAcrossDifferenceClassificationInASingleDocument = {
    name: i18n.t("youtube_List.Group_Revenue_Items_Across_Difference_Classification_In_A_Single_Document"),
    url: "KZu0pwpEKEg",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const searchExpenseRecordByClassification = {
    name: i18n.t("youtube_List.Search_Expense_Record_By_Classification"),
    url: "nc0BMV3tUJM",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const searchRevenueDocumentByClassification = {
    name: i18n.t("youtube_List.Search_Revenue_Document_By_Classification"),
    url: "uc_XG0PZcVY",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const createComparativeReportsForClassifiedGroups = {
    name: i18n.t("youtube_List.Create_Comparative_Reports_For_Classified_Groups"),
    url: "lu1TxorKubU",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const createDetailedReportsForClassifiedGroups = {
    name: i18n.t("youtube_List.Create_Detailed_Reports_For_Classified_Groups"),
    url: "IakXS0AfwIk",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const generateBusinessAnalystReportsForManagement = {
    name: i18n.t("youtube_List.Generate_Business_Analyst_Reports_For_Management"),
    url: "Hv7EBpmh2aI",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };

  switch (urlName) {
    case "custom":
      youtubeUrlList = [createComparativeReportsForClassifiedGroups, createDetailedReportsForClassifiedGroups];
      break;
    case "customDashboardDetail":
      youtubeUrlList = [createComparativeReportsForClassifiedGroups, createDetailedReportsForClassifiedGroups];
      break;
    case "exampleDashboard":
      youtubeUrlList = [createComparativeReportsForClassifiedGroups, createDetailedReportsForClassifiedGroups];
      break;
    case "executiveSummary":
      youtubeUrlList = [generateBusinessAnalystReportsForManagement];
      break;
    case "executiveSummaryTable":
      youtubeUrlList = [generateBusinessAnalystReportsForManagement];
      break;
    case "executiveSummaryCreate":
      youtubeUrlList = [generateBusinessAnalystReportsForManagement];
      break;
    case "executiveSummaryEdit":
      youtubeUrlList = [generateBusinessAnalystReportsForManagement];
      break;
    case "executiveSummaryDetail":
      youtubeUrlList = [generateBusinessAnalystReportsForManagement];
      break;
    default:
      youtubeUrlList = [
        setAndCreateClassificationGroup,
        editClassificationName,
        organizeExpenseRecordsWithClassification,
        organizeRevenueDocumentWithClassification,
        groupExpenseItemsAcrossDifferenceClassificationInASingleRecord,
        groupRevenueItemsAcrossDifferenceClassificationInASingleDocument,
        searchExpenseRecordByClassification,
        searchRevenueDocumentByClassification,
      ];
      break;
  }

  return youtubeUrlList;
}
